import prettyBytes from 'pretty-bytes';
import { ErrorCode, FileRejection } from 'react-dropzone';
import { DEFAULT_MAX_SIZE } from './CustomReports.constants';
import locale from './customReports-locale.json';
import { getCompletedLocaleText } from '../../../../locale/utils';

export function determineErrorMessage(fileRejections: FileRejection['errors']) {
  return fileRejections.map((error) => {
    if (error.code === ErrorCode.FileInvalidType) {
      return locale.errors.unsupportedFileType;
    }

    if (error.code === ErrorCode.FileTooLarge) {
      return getCompletedLocaleText(locale.errors.maximumFileSizeExceeded, { maxSize: prettyBytes(DEFAULT_MAX_SIZE) });
    }

    if (error.code === ErrorCode.TooManyFiles) {
      return locale.errors.tooManyFiles;
    }

    return getCompletedLocaleText(locale.errors.genericError, { errorMessage: error.message });
  });
}
